<div [formGroup]="form" class="grid gap-6">
    <mat-form-field appearance="fill">
        <mat-label>Tegund</mat-label>
        <mat-select formControlName="participationType">
            @for (type of participationTypes; track type) {
                <mat-option [value]="type">{{ type }}</mat-option>
            }
        </mat-select>
        <mat-error>Veldu tegund</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Aðal/varamaður ef við á</mat-label>
        <mat-select formControlName="memberRole">
            @for (role of memberRoles; track role) {
                <mat-option [value]="role">{{ role }}</mat-option>
            }
        </mat-select>
    </mat-form-field>

    <mat-radio-group formControlName="startOrEnd" class="flex flex-col gap-2">
        <mat-label class="font-medium mb-1">Upphaf eða lok?</mat-label>
        <mat-radio-button value="Start">Upphaf</mat-radio-button>
        <mat-radio-button value="End">Lok</mat-radio-button>
    </mat-radio-group>

    <mat-radio-group formControlName="isRelatedToLsrRole" class="flex flex-col gap-2">
        <mat-label class="font-medium mb-1">Er seta í stjórn/ráði tengd starfi hjá LSR?</mat-label>
        <mat-radio-button [value]="true">Já</mat-radio-button>
        <mat-radio-button [value]="false">Nei / á ekki við</mat-radio-button>
    </mat-radio-group>

    @if (form.get('isRelatedToLsrRole')?.value === true) {
        <mat-form-field appearance="fill">
            <mat-label>Þóknun fyrir setu</mat-label>
            <input matInput maxlength="11" numericFormat formControlName="compensation" />
            <span matSuffix>kr.</span>
        </mat-form-field>
    }

    <mat-form-field appearance="fill">
        <mat-label>Dagsetning upphaf/lok stjórnarsetu eða atvinnuþátttöku</mat-label>
        <input matInput class="date" formControlName="date" (click)="date.open()" [matDatepicker]="date" />
        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
        <mat-error>Dagsetning er skyldureitur</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Nafn fyrirtækis/félags</mat-label>
        <input matInput formControlName="companyName" />
        <mat-error>Nafn fyrirtækis/félags er skyldureitur</mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Tegund fyrirtækis/félags</mat-label>
        <input matInput formControlName="companyType" />
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Önnur tengsl við einstaklinga eða fyrirtæki ef við á</mat-label>
        <textarea matInput rows="6" formControlName="otherRelations"></textarea>
    </mat-form-field>

    <mat-form-field appearance="fill">
        <mat-label>Annað</mat-label>
        <textarea matInput rows="6" formControlName="otherDescription"></textarea>
    </mat-form-field>
</div>
